import React, { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import CtaSection from '../components/CtaSection';

const VeneersPage: React.FC = () => {
  const { language, translations } = useLanguage();

  useEffect(() => {
    // Set dynamic page title based on language
    let pageTitle = 'Veneers - SeaDent Mallorca';
    if (language === 'en') {
      pageTitle = 'Veneers - SeaDent Mallorca';
    } else if (language === 'es') {
      pageTitle = 'Carillas - SeaDent Mallorca';
    } else if (language === 'ru') {
      pageTitle = 'Виниры - SeaDent Майорка';
    }

    document.title = pageTitle;

    // Set meta description based on language
    let metaContent = 'Dünne Keramikschalen für ästhetische Korrekturen an Ihren Zähnen. Erleben Sie ein harmonisches, natürliches Erscheinungsbild bei SeaDent Mallorca.';
    if (language === 'en') {
      metaContent = 'Thin ceramic shells for aesthetic corrections to your teeth. Experience a harmonious, natural appearance at SeaDent Mallorca.';
    } else if (language === 'es') {
      metaContent = 'Finas carillas de cerámica para correcciones estéticas en sus dientes. Experimente una apariencia armoniosa y natural en SeaDent Mallorca.';
    } else if (language === 'ru') {
      metaContent = 'Тонкие керамические накладки для эстетической коррекции ваших зубов. Получите гармоничный, естественный вид в SeaDent Майорка.';
    }

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', metaContent);
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = metaContent;
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }, [language]);

  return (
    <main className="pt-20 lg:pt-32">
      <div className="bg-navy text-white py-20">
        <div className="container-custom">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">{translations.veneers.title}</h1>
          <p className="text-xl">{translations.veneers.intro.split('.')[0]}.</p>
        </div>
      </div>

      <section className="py-16">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            <div>
              <img
                src="/images/SeaDent Veneers.jpg"
                alt={translations.veneers.imageAlt}
                className="rounded-lg shadow-lg w-full"
              />
            </div>
            <div>
              <p className="mb-6 text-lg">{translations.veneers.description}</p>
            </div>
          </div>
        </div>
      </section>

      <CtaSection />
    </main>
  );
};

export default VeneersPage; 